import { useState, useEffect } from 'react'

// components
import Tracker from 'components/WorkflowTracker/Tracker/Tracker';
import Loading from 'components/Loading/Loading'

// apis
import {
  useGetWorkflow,
  usePutWorkflowTracker
} from 'api/hooks/workflows/useWorkflowsApi';

// context
import useWorkflowTracker from 'context/hooks/useWorkflowTracker'

// styles
import './WorkflowTracker.scss';

const WorkflowTracker = ({
  model,
  isReview = false,
  workflowId,
  showSettings = true,
  showAssignees = false,
  showDueDates = false,
  showDays = false,
  readOnly = false,
  overrideSettings = false
}) => {
  const {
    workflowTrackerData,
    setWorkflowTrackerData,
    isWorkflowComplete
  } = useWorkflowTracker()

  const [viewSettings, setViewSettings] = useState({
    showAssignees,
    showDueDates,
    showDays
  })

  useEffect(() => {
    if (isReview === false && overrideSettings === false) {
      const viewSettings = localStorage.getItem(`${model}-workflow-view-settings`);
      if (viewSettings) setViewSettings(JSON.parse(viewSettings))
    }
  }, [])

  useEffect(() => {
    if(overrideSettings) {
      setViewSettings({
        showAssignees,
        showDueDates,
        showDays
      })
    }
  }, [overrideSettings])

  const {
    data: workflowTrackerDataResp,
    isLoading: isWorkflowTrackerLoading
  } = useGetWorkflow({
    workflowId,
    workflowModel: 'request'
  })

  const putWorkflowTracker = usePutWorkflowTracker({
    workflowId,
    workflowModel: "request"
  })

  useEffect(() => {
    if (workflowTrackerDataResp) {
      setWorkflowTrackerData({
        ...workflowTrackerDataResp,
        state_data: {
          ...workflowTrackerDataResp.state_data,
          tracker_data: workflowTrackerDataResp.state_data.tracker_data.map(state => {
            return {
              ...state,
              start_state_date: state?.start_state_date?.split("T")?.[0],
              end_state_date: state?.end_state_date?.split("T")?.[0],
            }
          })
        }
      })
    }
  }, [workflowTrackerDataResp])

  const onChangeViewSettings = (key, val) => {
    let settings = {
      ...viewSettings,
      [key]: val
    }
    setViewSettings(settings)
    localStorage.setItem('request-workflow-view-settings', JSON.stringify(settings));
  }

  const viewSchema = {
    showAssignees: {
      label: "Assignees",
    },
    showDueDates: {
      label: "Due Dates",
    },
    showDays: {
      label: "Show days",
    }
  }

  return (
    <div className="workflow-tracker-container">
      {showSettings && <div className="workflow-tracker-header">
        {Object.keys(viewSchema).map(key => {
          return (
            <div
              key={key}
              className="settings-item"
              onClick={() => onChangeViewSettings(key, !viewSettings[key])}>
              {viewSettings[key]
                ? <i className="far fa-eye settings-item-off" />
                : <i className="far fa-eye-slash" />
              }
              {viewSchema[key].label}
            </div>
          )
        })}
      </div>
      }

      {isWorkflowTrackerLoading ? (
        <Loading />
      ) : (
        <Tracker
          model={model}
          workflowTrackerData={workflowTrackerData}
          readOnly={readOnly}
          viewSettings={{
            showAssignees: viewSettings.showAssignees,
            showDueDates: viewSettings.showDueDates,
            showDays: viewSettings.showDays,
          }}
          isWorkflowComplete={isWorkflowComplete}
          putWorkflowTracker={putWorkflowTracker}
        />
      )}
    </div>
  );
};

export default WorkflowTracker;